import React from 'react';
import PropTypes from 'prop-types';
import { Row, Col, Button } from 'reactstrap';

import { library } from '@fortawesome/fontawesome-svg-core'
import {
    faUserPlus
} from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
library.add(faUserPlus)

const UserHeader = ({ title, accountType, history }) => {
    return (
        <Row className="w-100 ml-0">
            <Col xs="12" sm="6" className="my-auto pl-0 text-left h3 font-weight-normal">
                Users / <strong>{title}</strong>
            </Col>
            <Col xs="12" sm="6" className="text-right mt-2 mt-sm-0 pr-0">
                <Button size="md" color='dark' onClick={() => onNewUser(history, accountType.toLowerCase())} className="filter-toggler">
                    {`New ${accountType}`}{'\u00A0'}
                    <FontAwesomeIcon
                        icon="user-plus"
                    />
                </Button>
            </Col>
        </Row>
    )
};

const onNewUser = (history, role) => {
    history.push({
        pathname: "/users/add",
        state: {
            role: role
        }
    });
}

UserHeader.propTypes = {
    title: PropTypes.string,
    accountType: PropTypes.string,
    history: PropTypes.object
};

export default UserHeader;



// WEBPACK FOOTER //
// ./src/components/blocks/UserHeader/UserHeader.js